<template>
    <div>
        <div v-for="crewAddress in crew.crew_addresses" :key="crewAddress.id" class="mb-5">
            <div class="card-title font-weight-bold">
                {{ crewAddress.address_type.name }} ADDRESS
                <template v-if="(isManning || isDesignatedPrincipal || isPrincipal || isPrincipalStaff) && !guest && !isKline">
                  <template v-if="crew.active == 1 || isSystemAdmin">
                    <button v-if="crewAddress.id === editCrewAddress.id"
                            class="btn btn-sm btn-xs btn-danger float-right ml-2"
                            title="Cancel Edit"
                            @click="editCrewAddress = {}"
                    >
                        <span class="fas fa-ban"></span>
                    </button>
                    <button class="btn btn-sm btn-xs btn-warning font-weight-bold float-right mb-1"
                            @click="updateEditCrewAddress(crewAddress)"
                    >
                        <span class="fas fa-edit"></span>
                        {{ crewAddress.id === editCrewAddress.id ? 'Update' : 'Edit' }}
                    </button>
                  </template>
                </template>
                <hr class="mt-1 border-dark"/>
            </div>
            <div class="form-group form-row mb-1">
                <label class="col col-sm-2 col-form-label font-weight-bolder text-left form-label-xs"
                       :for="'editCountry' + crewAddress.id"
                >
                    Country:
                </label>
                <div class="col col-sm-9">
                    <select :id="'editCountry' + crewAddress.id"
                      v-if="crewAddress.id === editCrewAddress.id"
                            class="form-control form-control-xs"
                            @change="updateRegionKeys($event,true)"
                    >
                        <option :value="null">--- Select Country ---</option>
                        <option v-for="country in natlKeys" :key="country.id"
                                :value="country.id"
                                :selected="country.id === crewAddress.country.id"
                        >{{ country.name }}</option>
                    </select>
                    <div v-else style="padding-left: 0.75rem">
                      {{ crewAddress.country.name }}
                    </div>
                </div>
            </div>


            <div class="form-group form-row mb-1">
                <label class="col col-sm-2 col-form-label font-weight-bolder text-left form-label-xs"
                       :for="'region' + crewAddress.id"
                >
                    Region:
                </label>
                <div class="col col-sm-9" v-if="crewAddress.id === editCrewAddress.id">

                    <select :id="'city' + crewAddress.id"
                      class="form-control form-control-xs text-uppercase"
                      v-model="editCrewAddress.region_id"
                      @change="(e) => updateCitiesOptions(e.target.value)"
                      :disabled="options.regions.length === 0"
                    >
                        <option :value="null">--- Select Region ---</option>
                        <option v-for="region in options.regions" :key="region.id" :value="region.id">
                          {{ region.name }}
                        </option>
                    </select>
                </div>

                <div class="col col-sm-9" v-else>
                    <input type="text" readonly :id="'region' + crewAddress.id"
                           class="form-control form-control-xs form-display h-1x"
                           v-if="crewAddress.region"
                           v-model="crewAddress.region.name"
                    >
                    <input type="text" readonly :id="'region' + crewAddress.id"
                           class="form-control form-control-xs form-display h-1x"
                           v-else
                           value="------"
                    >
                </div>
            </div>


            <div class="form-group form-row mb-1">
                <label class="col col-sm-2 col-form-label font-weight-bolder text-left form-label-xs"
                       :for="'city' + crewAddress.id"
                >
                    City:
                </label>

                <div class="col col-sm-9" v-if="crewAddress.id === editCrewAddress.id">
                    <select :id="'city' + crewAddress.id"
                      v-model="editCrewAddress.city_id"
                      :disabled="options.cities.length === 0"
                      class="form-control form-control-xs text-uppercase"
                    >
                        <option :value="null">--- Select City ---</option>
                        <option v-for="city in options.cities" :key="city.id" :value="city.id">
                          {{ city.name }}
                        </option>
                    </select>
                </div>

                <div class="col col-sm-9" v-else>
                    <input type="text" readonly :id="'city' + crewAddress.id"
                           class="form-control form-control-xs form-display h-1x"
                           v-if="crewAddress.city"
                           v-model="crewAddress.city.name"
                    >
                    <input type="text" readonly :id="'city' + crewAddress.id"
                           class="form-control form-control-xs form-display h-1x"
                           v-else
                           value="------"
                    >
                </div>
            </div>

            <div class="form-group form-row mb-1">
                <label class="col col-sm-2 col-form-label font-weight-bolder text-left form-label-xs"
                       :for="'address' + crewAddress.id"
                >
                    Address:
                </label>
                <div class="col col-sm-9">
                    <textarea name="address" :id="'address' + crewAddress.id"
                              class="form-control form-control-xs"
                              v-model="editCrewAddress.address"
                              v-if="crewAddress.id === editCrewAddress.id"
                              required
                    ></textarea>
                    <textarea name="address" :id="'address' + crewAddress.id"
                              class="form-control form-control-xs"
                              v-model="crewAddress.address"
                              readonly
                              v-else
                    ></textarea>
                </div>
            </div>

        </div>

      <template v-if="(isManning || isDesignatedPrincipal || isPrincipal || isPrincipalStaff) && !guest && !isKline">
        <template v-if="crew.active == 1 || isSystemAdmin">
          <button class="btn btn-sm btn-xs btn-outline-primary font-weight-bolder float-right mb-1"
                  title="Add Crew Address" data-toggle="modal" data-target="#addCrewAddress"
          >
            <span class="fas fa-plus"></span>
            Add Address
          </button>
        </template>
      </template>



        <div class="modal fade" id="addCrewAddress"
             tabindex="-1" role="dialog" aria-labelledby="addCrewAddressTitle"
             v-if="(isManning || isDesignatedPrincipal || isPrincipal || isPrincipalStaff)"
        >
            <div class="modal-dialog modal-dialog-centered" role="document">
                <form class="modal-content" @submit.prevent="confirmAddNewCrewAddress">
                    <div class="modal-header">
                        <h5 class="modal-title font-weight-bolder" id="addCrewAddressTitle">
                            Add Crew Address
                        </h5>
                        <button type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                id="closeAddCrewLanguage"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">

                        <div class="form-group form-row mb-1" :class="{'has-error': newCrewAddressErrors.address_type_id}">
                            <label class="col col-sm-3 col-form-label font-weight-bolder text-right"
                                   for="addressType"
                            >
                                Address Type:
                            </label>
                            <div class="col col-sm-9">
                                <select id="addressType" required
                                        class="form-control form-control-xs"
                                        v-model="newCrewAddress.address_type_id"
                                >
                                    <option :value="null">--- Address Type ---</option>
                                    <option v-for="addressTypeKey in addressTypeKeys" :key="addressTypeKey.id"
                                            :value="addressTypeKey.id"
                                    >{{ addressTypeKey.name }}</option>
                                </select>
                                <span class="help-block" v-if="newCrewAddressErrors.address_type_id !== ''">
                                    <small><strong>{{ newCrewAddressErrors.address_type_id }}</strong></small>
                                </span>
                            </div>
                        </div>

                        <div class="form-group form-row mb-1">
                            <label class="col col-sm-3 col-form-label font-weight-bolder text-right"
                                   for="newRegion"
                            >
                                Country:
                            </label>
                            <div class="col col-sm-9">
                                <select id="newCountry"
                                        class="form-control form-control-xs"
                                        @change="updateRegionKeys($event)"
                                >
                                    <option :value="null">--- Select Country ---</option>
                                    <option v-for="country in natlKeys" :key="country.id" :value="country.id">
                                      {{ country.name }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div class="form-group form-row mb-1" :class="{'has-error': newCrewAddressErrors.region_id}">
                            <label class="col col-sm-3 col-form-label font-weight-bolder text-right"
                              for="newRegion"
                            >
                                Region:
                            </label>
                            <div class="col col-sm-9">
                                <select id="newRegion"
                                  v-model="newCrewAddress.region_id"
                                  @change="(e) => updateCitiesOptions(e.target.value)"
                                  :disabled="options.regions.length === 0"
                                  class="form-control form-control-xs text-uppercase"
                                >
                                    <option :value="null">--- Select Region ---</option>
                                    <option v-for="regionKey in options.regions" :key="regionKey.id"
                                            :value="regionKey.id">{{ regionKey.name }} - {{ regionKey.description }}</option>
                                </select>
                                <span class="help-block" v-if="newCrewAddressErrors.region_id !== ''">
                                    <small><strong>{{ newCrewAddressErrors.region_id }}</strong></small>
                                </span>
                            </div>
                        </div>

                        <div class="form-group form-row mb-1" :class="{'has-error': newCrewAddressErrors.city_id}">
                            <label class="col col-sm-3 col-form-label font-weight-bolder text-right"
                                   for="newCity"
                            >
                                City:
                            </label>
                            <div class="col col-sm-9">
                                <select v-model="newCrewAddress.city_id" id="newCity"
                                  :disabled="options.cities.length === 0"
                                  class="form-control form-control-xs text-uppercase"
                                >
                                    <option :value="null">--- Select City ---</option>
                                    <option v-for="city in options.cities" :key="city.id" :value="city.id">
                                      {{ city.name }}
                                    </option>
                                </select>
                                <span class="help-block" v-if="newCrewAddressErrors.city_id !== ''">
                                    <small><strong>{{ newCrewAddressErrors.city_id }}</strong></small>
                                </span>
                            </div>
                        </div>

                        <div class="form-group form-row mb-1" :class="{'has-error': newCrewAddressErrors.address}">
                            <label class="col col-sm-3 col-form-label font-weight-bolder text-right"
                                   for="newAddress"
                            >
                                Address:
                            </label>
                            <div class="col col-sm-9">
                                <textarea id="newAddress" required
                                          class="form-control form-control-xs"
                                          v-model="newCrewAddress.address"
                                ></textarea>
                                <span class="help-block" v-if="newCrewAddressErrors.address !== ''">
                                    <small><strong>{{ newCrewAddressErrors.address }}</strong></small>
                                </span>
                            </div>
                        </div>

                    </div>

                    <div class="modal-footer">
                        <button type="submit" class="btn btn-sm btn-outline-primary font-weight-bolder">
                            <span class="fas fa-plus"></span>
                            Save
                        </button>
                    </div>

                </form>
            </div>
        </div>

    </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex';
    import { vueAppMixin } from "../../../../../../../mixins/vueAppMixin";
    import { formMixin } from "../../../../../../../mixins/formMixin";
    import {gateMixin} from "@/mixins/gateMixin";
    import {RegionService} from "@/services/RegionService";
    import {CityService} from "@/services/CityService";
    import {cloneDeep} from "lodash/lang"

    export default {
        name: "CrewAddress",
        mixins: [ vueAppMixin, formMixin, gateMixin ],
        data() {
            return {
                newCrewAddress: {},
                newCrewAddressErrors: [],
                editCrewAddress: {},
                editCrewAddressErrors: {},
                tempCityId:null,
                tempRegionId:null,
                options: {
                  regions: [],
                  cities: []
                }
            }
        },

        methods: {
            ...mapActions([ 'getAddressTypeKeys', 'getRegionKeys', 'getCityKeys', 'getNatlKeys', 'addNewCrewAddress', 'updateCrewAddress' ]),

            async confirmAddNewCrewAddress() {
                if(await this.confirmCreateAlert()) {
                    let newCrewAddress = await this.addNewCrewAddress(this.newCrewAddress);
                    if(newCrewAddress) {
                        if(newCrewAddress.errors) {
                            this.newCrewAddressErrors = newCrewAddress.errors;
                        } else {
                            this.successAlert('New Crew Address Successfully Created', 'CREATE');
                            this.refreshNewCrewAddress();
                            document.getElementById('closeAddCrewLanguage').click();
                        }
                    }
                }
            },

            refreshNewCrewAddress() {
                this.newCrewAddress = { crew_id: this.crew.id, address_type_id: null, region_id: null, city_id: null };
                this.newCrewAddressErrors = [];
            },

            async updateRegionKeys(e, isUpdate = false) {
              this.options.regions = await RegionService.getRegionKeys(e.target.value) ?? []
              this.options.cities = []

              if (e.target.value !== 1 && !isUpdate) {
                this.newCrewAddress.region_id = null
                this.newCrewAddress.country_id = e.target.value
                this.newCrewAddress.city_id = null
              } else {
                this.editCrewAddress.country_id = e.target.value
                this.editCrewAddress.region_id = null
                this.editCrewAddress.city_id = null
                if (this.editCrewAddress.city_id && this.editCrewAddress.region_id) {
                  this.tempCityId = this.editCrewAddress.city_id;
                  this.tempRegionId = this.editCrewAddress.region_id;

                } else {
                  this.editCrewAddress.city_id = this.tempCityId
                  this.editCrewAddress.region_id = this.tempRegionId
                  this.tempCityId = null;
                  this.tempRegionId = null
                }

              }
            },

            async updateCitiesOptions(region) {
              this.editCrewAddress.city_id = null
              this.options.cities = await CityService.getCityKeys(region) ?? []
            },

            async updateEditCrewAddress(crewAddress) {
              //Check if we click the Edit button
              if (this.editCrewAddress.id !== crewAddress.id) {
                this.editCrewAddress = cloneDeep(crewAddress)
                this.options = {
                  regions: crewAddress.country_id ? await RegionService.getRegionKeys(crewAddress.country_id) : [],
                  cities: crewAddress.region_id ? await CityService.getCityKeys(crewAddress.region_id) : []
                }

                return
              }

              if(! await this.confirmUpdate()) {
                return
              }

              const updatedCrewAddress = await this.updateCrewAddress({
                crewAddressId: this.editCrewAddress.id,
                region_id: this.editCrewAddress.region_id,
                country_id: this.editCrewAddress.country_id,
                city_id: this.editCrewAddress.city_id,
                address: this.editCrewAddress.address
              })

              if (updatedCrewAddress.errors) {
                  this.editCrewAddressErrors = updatedCrewAddress.errors
                  return
              }

              this.successAlert('Crew Address Successfully Updated', 'UPDATE')
              this.editCrewAddress = {}
              this.editCrewAddressErrors = {}
            },

            async initializeData() {
                await this.getAddressTypeKeys();
                await this.getNatlKeys();
                // await this.getCityKeys();
                await this.refreshNewCrewAddress();
            }
        },

        computed: {
            ...mapGetters([ 'crew', 'addressTypeKeys', 'regionKeys', 'cityKeys', 'natlKeys','countryKeyId' ]),
           finalCityKeys(){
              return this.countryKeyId == 1  ? this.cityKeys : [];
           }
        },

        created() {
            this.initializeData();
        },

    }
</script>

<style scoped>

</style>
